import { UnitWithTransmissionStatus } from 'src/app/units/models/unit-transmission-status';
import { OperationGroup } from '../models/collection-vehicle.model';

export function unitsToCollection(
  units: UnitWithTransmissionStatus[]
): OperationGroup[] {
  const operationsMap = new Map<number, OperationGroup>();

  units.forEach((unit) => {
    const opKey = unit.idOperation ?? 0;
    const groupKey = unit.idGrupo ?? 0;
    const convoyKey = unit.idConvoy ?? 0;

    if (!operationsMap.has(opKey)) {
      operationsMap.set(opKey, {
        idOperation: opKey,
        nameOperation: opKey === 0 ? 'Sin Operación' : unit.operation,
        groups: [],
      });
    }
    const operation = operationsMap.get(opKey)!;

    let group = operation.groups.find((g) => g.idGrupo === groupKey);
    if (!group) {
      group = {
        idGrupo: groupKey,
        nameGroup: groupKey === 0 ? 'Sin Grupo' : unit.group,
        convoys: [],
      };
      operation.groups.push(group);
    }

    let convoy = group.convoys.find((c) => c.idConvoy === convoyKey);
    if (!convoy) {
      convoy = {
        idConvoy: convoyKey,
        nameConvoy: convoyKey === 0 ? 'Sin Convoy' : unit.convoy,
        units: [],
      };
      group.convoys.push(convoy);
    }
    convoy.units.push(unit);
  });

  const sortedOperations = Array.from(operationsMap.values()).sort((a, b) =>
    a.idOperation === 0 ? 1 : b.idOperation === 0 ? -1 : 0
  );

  sortedOperations.forEach((operation) => {
    operation.groups.sort((a, b) =>
      a.idGrupo === 0 ? 1 : b.idGrupo === 0 ? -1 : 0
    );
    operation.groups.forEach((group) => {
      group.convoys.sort((a, b) =>
        a.idConvoy === 0 ? 1 : b.idConvoy === 0 ? -1 : 0
      );
    });
  });

  return sortedOperations;
}
